import React from 'react';
import { MuiThemeProvider } from '@material-ui/core';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';

// import { StateProvider } from '../shared/state/StateContext';
// import reducer from '../shared/state/reducers/MainReducer';
// import initialState from '../shared/state/initalState';
import { theme } from '../shared/styles/colors';
import Login from './Components/Login';
import Dashboard from './Components/Dashboard/Dashboard';
import client from '../shared/apollo/ApolloClient';

const App: React.FC = () => (
  <MuiThemeProvider theme={theme}>
    {/* TODO */}
    {/* <StateProvider initialState={initialState} reducer={reducer}> */}
    <ApolloProvider client={client}>
      <Router>
        <Switch>
          <Route path="/login" render={() => <Login basePath="/login" />} />
          <Route path="/" component={Dashboard} />
        </Switch>
      </Router>
      {/* </StateProvider> */}
    </ApolloProvider>
  </MuiThemeProvider>
);

export default App;
